import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BreadcrumbNav from '@/components/feature/BreadcrumbNav';

export default function AboutPage() {
  const { t } = useTranslation();
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    document.title = t('about.pageTitle');
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [t]);

  useEffect(() => {
    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.id = 'faq-schema';

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': [
        {
          '@type': 'Question',
          'name': '51吃瓜网是什么平台？',
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': '51吃瓜网是国内领先的娱乐爆料聚合平台，每日追踪网红黑料、明星塌房、博主反差视频、聊天记录泄露等热点爆料内容，为用户提供最新鲜、最全面的吃瓜体验。',
          },
        },
        {
          '@type': 'Question',
          'name': '51吃瓜网的内容是否真实可靠？',
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': '我们的内容经过严格审核，内容真实率高达99.7%。我们拒绝传播虚假谣言，每一条爆料都经过多方核实后才进行发布。',
          },
        },
        {
          '@type': 'Question',
          'name': '如何与51吃瓜网进行商务合作？',
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': '您可以通过关于我们页面的商务合作表单提交合作意向，hello@zwrn.cn。我们期待与更多优秀品牌携手合作。',
          },
        },
        {
          '@type': 'Question',
          'name': '51吃瓜网如何获取最新更新？',
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': '您可以收藏51吃瓜网官方网站，或关注我们的社交媒体账号（微博、B站等），第一时间获取最新的吃瓜爆料内容。',
          },
        },
      ],
    };
    faqScript.textContent = JSON.stringify(faqSchema);

    const existing = document.getElementById('faq-schema');
    if (existing) existing.remove();
    document.head.appendChild(faqScript);

    const aboutScript = document.createElement('script');
    aboutScript.type = 'application/ld+json';
    aboutScript.id = 'about-schema';

    const aboutSchema = {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      'name': '关于51吃瓜网',
      'description': t('about.hero.desc'),
      'url': 'http://zwrn.cn/about',
      'isPartOf': {
        '@type': 'WebSite',
        'name': '51吃瓜网',
        'url': 'http://zwrn.cn/',
      },
    };
    aboutScript.textContent = JSON.stringify(aboutSchema);

    const existingAbout = document.getElementById('about-schema');
    if (existingAbout) existingAbout.remove();
    document.head.appendChild(aboutScript);

    return () => {
      const faq = document.getElementById('faq-schema');
      const about = document.getElementById('about-schema');
      if (faq) faq.remove();
      if (about) about.remove();
    };
  }, [t]);

  const breadcrumbItems = [
    { label: t('breadcrumb.home'), href: '/' },
    { label: t('breadcrumb.about') },
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: t('about.values.truth.title'),
      desc: t('about.values.truth.desc'),
    },
    {
      icon: 'ri-flashlight-line',
      title: t('about.values.speed.title'),
      desc: t('about.values.speed.desc'),
    },
    {
      icon: 'ri-stack-line',
      title: t('about.values.depth.title'),
      desc: t('about.values.depth.desc'),
    },
    {
      icon: 'ri-group-line',
      title: t('about.values.community.title'),
      desc: t('about.values.community.desc'),
    },
  ];

  const stats = [
    { value: '100万+', label: '日活跃用户' },
    { value: '5000+', label: '每日爆料更新' },
    { value: '50万+', label: '视频资源库' },
    { value: '99.7%', label: '内容真实率' },
  ];

  const teamMembers = [
    {
      name: '张晓明',
      role: '创始人 & CEO',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20abstract%20portrait%20in%20warm%20cream%20tones%2C%20minimalist%20geometric%20style%2C%20modern%20editorial%20aesthetic%2C%20sophisticated%20atmosphere%2C%20soft%20lighting%2C%20clean%20composition%20with%20subtle%20background%20gradient%2C%20professional%20yet%20approachable%20feel%2C%20no%20identifiable%20facial%20features%2C%20artistic%20representation&width=200&height=200&seq=team-01&orientation=squarish',
    },
    {
      name: '李思涵',
      role: '首席内容官',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20professional%20portrait%20in%20muted%20sage%20green%20palette%2C%20minimalist%20geometric%20design%2C%20modern%20editorial%20photography%20style%2C%20warm%20sophisticated%20atmosphere%2C%20soft%20diffused%20lighting%2C%20elegant%20composition%2C%20artistic%20representation%20without%20identifiable%20features&width=200&height=200&seq=team-02&orientation=squarish',
    },
    {
      name: '王浩然',
      role: '技术总监',
      avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20professional%20portrait%20in%20warm%20terracotta%20tones%2C%20clean%20geometric%20style%2C%20modern%20editorial%20aesthetic%2C%20professional%20yet%20approachable%20feel%2C%20soft%20atmospheric%20lighting%2C%20elegant%20simple%20composition%2C%20artistic%20representation%20without%20facial%20details&width=200&height=200&seq=team-03&orientation=squarish',
    },
    {
      name: '陈雨萱',
      role: '运营副总裁',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20professional%20portrait%20in%20soft%20taupe%20and%20cream%20palette%2C%20minimalist%20geometric%20style%2C%20modern%20editorial%20photography%2C%20sophisticated%20warm%20atmosphere%2C%20gentle%20diffused%20lighting%2C%20clean%20elegant%20composition%2C%20artistic%20representation%20without%20identifiable%20features&width=200&height=200&seq=team-04&orientation=squarish',
    },
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('company_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    try {
      const response = await fetch('http://zwrn.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse errors
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormError(serverMsg || t('about.contact.form.error'));
        setFormStatus('error');
      }
    } catch {
      setFormError(t('about.contact.form.error'));
      setFormStatus('error');
    }
  };

  return (
    <>
      <main>
        <Navbar />

        <section className="pt-24 md:pt-28 pb-16 md:pb-24 bg-background-50">
          <BreadcrumbNav items={breadcrumbItems} />

          <div className="w-full px-6 md:px-10 lg:px-16 mt-6">
            <div className="text-center mb-16 md:mb-20">
              <h1 className="font-heading text-4xl md:text-6xl font-black text-foreground-950 leading-tight mb-6">
                {t('about.hero.heading')}
              </h1>
              <p className="text-lg md:text-xl text-accent-600 font-medium mb-4">
                {t('about.hero.subheading')}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                {t('about.hero.desc')}
              </p>
            </div>

            <div className="max-w-4xl mx-auto mb-20 md:mb-28">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
                {t('about.story.heading')}
              </h2>
              <div className="flex flex-col gap-5">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.story.paragraph1')}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.story.paragraph2')}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.story.paragraph3')}
                </p>
              </div>
            </div>

            <div className="bg-secondary-50 rounded-lg p-8 md:p-12 mb-20 md:mb-28">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  {t('about.stats.heading')}
                </h2>
                <p className="text-sm text-foreground-500">{t('about.stats.desc')}</p>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
                {stats.map((stat, idx) => (
                  <div key={idx} className="text-center">
                    <div className="font-heading text-4xl md:text-5xl font-black text-primary-700 mb-2">
                      {stat.value}
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="max-w-4xl mx-auto mb-20 md:mb-28">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
                {t('about.values.heading')}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
                {values.map((item, idx) => (
                  <div key={idx} className="bg-background-50 rounded-lg p-6 md:p-8 flex gap-5">
                    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-lg text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-20 md:mb-28">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
                {t('about.team.heading')}
              </h2>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto">
                {teamMembers.map((member, idx) => (
                  <div key={idx} className="text-center">
                    <div className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden mx-auto mb-4 bg-background-100">
                      <img
                        src={member.avatar}
                        alt={member.name}
                        className="w-full h-full object-cover"
                        title={member.name}
                      />
                    </div>
                    <h3 className="font-semibold text-sm text-foreground-900">{member.name}</h3>
                    <p className="text-xs text-foreground-500 mt-1">{member.role}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  {t('about.contact.heading')}
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto">
                  {t('about.contact.desc')}
                </p>
              </div>

              <div className="flex flex-col lg:flex-row gap-10 md:gap-14">
                <div className="flex-1">
                  <form
                    onSubmit={handleSubmit}
                   
                    className="flex flex-col gap-4"
                  >
                    <div>
                      <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
                        {t('about.contact.form.name')}
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder={t('about.contact.form.namePlaceholder')}
                        className="w-full rounded-md px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
                        {t('about.contact.form.company')}
                      </label>
                      <input
                        type="text"
                        name="company"
                        placeholder={t('about.contact.form.companyPlaceholder')}
                        className="w-full rounded-md px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
                        {t('about.contact.form.email')}
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder={t('about.contact.form.emailPlaceholder')}
                        className="w-full rounded-md px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
                        {t('about.contact.form.phone')}
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder={t('about.contact.form.phonePlaceholder')}
                        className="w-full rounded-md px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                    </div>
                    <input
                      type="text"
                      name="company_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="form-protection-field"
                    />
                    <div>
                      <label className="block text-xs font-semibold text-foreground-700 mb-1.5">
                        {t('about.contact.form.message')}
                      </label>
                      <textarea
                        name="message"
                        rows={4}
                        maxLength={500}
                        required
                        placeholder={t('about.contact.form.messagePlaceholder')}
                        className="w-full rounded-md px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                      ></textarea>
                    </div>

                    {formStatus === 'error' && formError && (
                      <div className="text-xs text-red-600 bg-red-50 rounded-md px-4 py-2.5">
                        {formError}
                      </div>
                    )}
                    {formStatus === 'success' && (
                      <div className="text-xs text-green-700 bg-green-50 rounded-md px-4 py-2.5">
                        {t('about.contact.form.success')}
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                    >
                      <i className="ri-send-plane-line text-sm w-4 h-4 flex items-center justify-center"></i>
                      {formStatus === 'submitting'
                        ? t('about.contact.form.submitting')
                        : t('about.contact.form.submit')}
                    </button>
                  </form>
                </div>

                <div className="lg:w-72 flex-shrink-0">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-5">
                    {t('about.contact.info.heading')}
                  </h3>
                  <div className="flex flex-col gap-5">
                    <div>
                      <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                        {t('about.contact.info.address')}
                      </h4>
                      <p className="text-sm text-foreground-700">{t('about.contact.info.addressValue')}</p>
                    </div>
                    <div>
                      <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                        {t('about.contact.info.phone')}
                      </h4>
                      <p className="text-sm text-foreground-700">{t('about.contact.info.phoneValue')}</p>
                    </div>
                    <div>
                      <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                        {t('about.contact.info.email')}
                      </h4>
                      <p className="text-sm text-foreground-700">{t('about.contact.info.emailValue')}</p>
                    </div>
                    <div>
                      <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                        {t('about.contact.info.hours')}
                      </h4>
                      <p className="text-sm text-foreground-700">{t('about.contact.info.hoursValue')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}